<template>
  <div :style="!standalone ? 'margin:20px' : 'margin:5px'">
    <div v-if="!standalone" style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Vehicle Status Manager</span><br/>
      <div style="font-style: italic; font-size: 18px; padding-bottom: 15px; margin-right: 10px">
        latest status for all vehicles, status can be manually updated using the dropdown
<!--        <span style="padding-left:5px;float:right"><b-button variant="success" size="sm" :to="{ name: 'vehicle_status_history' }"><b style="color:white;font-style:normal;">status history</b></b-button></span>-->
        <span style="float:right;">
          <b-button variant="success" size="sm" @click="view_more_info = !view_more_info"><b>more info</b></b-button>
        </span>
      </div>
    </div>
    <div v-if="standalone">
      <span style="font-size: 20px; font-weight: bold; margin-bottom: 10px;" class="d-flex align-items-center justify-content-center">
        <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img style="margin-top:-5px" width="40" src="favicon.ico"/></a>&nbsp;VSM&nbsp;&nbsp;
        <span v-if="selected_base">&nbsp;-&nbsp;{{selected_base}}</span>
        <span v-if="return_mode">&nbsp;- Wash Mode</span>
        <span v-if="cleaning_mode">&nbsp;-&nbsp;Cleaning</span>
        <span v-if="maintenance_mode">&nbsp;-&nbsp;Maintenance</span>
        <span v-if="driver_mode">&nbsp;-&nbsp;Driver</span>
        <b-spinner v-if="reloading" style="width: 1.8rem; height: 1.8rem"></b-spinner><span v-else style="width: 1.8rem; height: 1.8rem">&nbsp;</span>
        &nbsp;&nbsp;&nbsp;&nbsp;<b-button v-if="!driver_mode" variant="success" size="sm" @click="view_more_info = !view_more_info"><b>more info</b></b-button>
      </span>
    </div>

    <b-modal title="Here are details on the statuses and filters used for the VSM" size="xl" v-model="view_more_info" ok-only>
      <br/>
      <h4>Vehicle Status</h4>
      <span v-if="washed_enabled">
        &nbsp;&nbsp;READY - automatically set by the system when a vehicle has been cleaned and washed and is ready for service
        <br/>&nbsp;&nbsp;CLEANED - indicates that the vehicle interior has been cleaned (manually managed)
        <br/>&nbsp;&nbsp;WASHED - indicates that the vehicle exterior has been washed (manually managed)
      </span>
      <span v-else>
        &nbsp;&nbsp;CLEANED - indicates that the vehicle has been cleaned (manually managed)
      </span>
      <br/>&nbsp;&nbsp;DIRTY - automatically set by the system when a vehicle arrives back to the finish location or yard
      <br/>&nbsp;&nbsp;OUT - automatically set by the system when a vehicle leaves the start location for a planned booking
      <br/>&nbsp;&nbsp;OOS - out of service (manually managed)
      <br><hr/>
      <h4>VSM Standalone Mode</h4>
      &nbsp;&nbsp;provides a standalone view that refreshes every minute to keep all teams in sync (no login required)
      <br/>&nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-v1/reload/' + this.tenant_id">click here to load the standalone Dispatch VSM (by depart time)</a>
      <br/>&nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-es/reload/' + this.tenant_id">click here to load the standalone mobile Wash VSM in Spanish</a>
      <br/>&nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-v1/reloadreturn/' + this.tenant_id">click here to load the standalone Wash VSM (by return time)</a>
      <div v-if="summary && summary.visible_driver_fields">&nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-v1/driver/' + this.tenant_id">click here to load the standalone Driver VSM</a></div>
      <div v-if="summary && summary.visible_cleaning_fields">&nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-v1/cleaning/' + this.tenant_id">click here to load the standalone Cleaning VSM</a></div>
      <div v-if="summary && summary.visible_maintenance_fields">&nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-v1/maintenance/' + this.tenant_id">click here to load the standalone Maintenance VSM</a></div>
      <span v-if="base_options.length > 2">
        <br/>&nbsp;&nbsp;<b>Click on a base to load the Dispatch VSM for that base.</b><br/>
        <span v-if="base.value != ''" v-for="base in base_options">
          &nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-v1/reload/' + tenant_id + '/' + base.value">{{base.value}}</a>&nbsp;&nbsp;|
        </span>
        <br/>
        <br/>&nbsp;&nbsp;<b>Click on a base to load the Wash VSM (by return time) for that base.</b><br/>
        <span v-if="base.value != ''" v-for="base in base_options">
          &nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-v1/reloadreturn/' + tenant_id + '/' + base.value">{{base.value}}</a>&nbsp;&nbsp;|
        </span>
        <div v-if="summary && summary.visible_driver_fields">
          <br/>&nbsp;&nbsp;<b>Click on a base to load the Driver VSM for that base.</b><br/>
          <span v-if="base.value != ''" v-for="base in base_options">
            &nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-v1/driver/' + tenant_id + '/' + base.value">{{base.value}}</a>&nbsp;&nbsp;|
          </span>
        </div>
        <div v-if="summary && summary.visible_cleaning_fields">
          <br/>&nbsp;&nbsp;<b>Click on a base to load the Cleaning VSM for that base.</b><br/>
          <span v-if="base.value != ''" v-for="base in base_options">
            &nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-v1/cleaning/' + tenant_id + '/' + base.value">{{base.value}}</a>&nbsp;&nbsp;|
          </span>
        </div>
        <div v-if="summary && summary.visible_maintenance_fields">
          <br/>&nbsp;&nbsp;<b>Click on a base to load the Maintenance VSM for that base.</b><br/>
          <span v-if="base.value != ''" v-for="base in base_options">
            &nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-v1/maintenance/' + tenant_id + '/' + base.value">{{base.value}}</a>&nbsp;&nbsp;|
          </span>
        </div>
      </span>
      <br><hr/>
      <span v-if="summary && summary.aws_phone_number">
        <h4>Update Status & Notes Over SMS</h4>
        &nbsp;&nbsp;simply send a text in one of the following formats: to #{{summary.aws_phone_number | prettyPhoneNumber}}<br>
        &nbsp;&nbsp;&nbsp;&nbsp;to update the status only, send '[status] [vehicle name]' - for example 'cleaned 123'<br>
        &nbsp;&nbsp;&nbsp;&nbsp;to update the notes only, send 'notes [vehicle name], [notes]' - for example 'notes 123, issue found'<br>
        &nbsp;&nbsp;&nbsp;&nbsp;to update the status & notes, send '[status] [vehicle name], [notes]' - for example 'cleaned 123, issue found'<br>
        &nbsp;&nbsp;&nbsp;&nbsp;to clear notes, send '[notes] [vehicle name]' - for example 'notes 123'
      </span>
    </b-modal>

    <b-modal title="Add Record" size="md" v-model="show_add_vehicle_info_modal" ok-only>
        <div>
          Vehicle Name: <b-form-input v-model="add_vehicle_info_model.name" required/>
          Base: <b-form-input v-model="add_vehicle_info_model.start_base" required/>
          Notes: <b-form-input v-model="add_vehicle_info_model.notes" required/>
          Next Scheduled Time: <datetime style="margin: 5px;border-radius: 5px;" format="MM/DD/YYYY H:i" :value="add_vehicle_info_model.next_scheduled_time" @input="add_vehicle_info_model.next_scheduled_time=$event"/>
        </div>
        <br/>
        <b-button v-if="!loading" variant="success" size="md" @click="add_vehicle_info_record()">Save</b-button>
    </b-modal>

    <div v-if="!loading && !mobile_view && !driver_mode && summary">
      <div class="row" style="margin: 20px 0px 25px 0px; font-weight: bold; font-size: 20px;">
        <div @click="filter_by_status(null)" :style="selected_vehicle_status==null ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col total" style="width: 250px; border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
        <div v-if="washed_enabled" @click="filter_by_status('ready')" :style="selected_vehicle_status=='ready' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col ready">Ready-{{ready_cnt}}</div>
        <div @click="filter_by_status('cleaned')" :style="selected_vehicle_status=='cleaned' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col cleaned">Clean-{{clean_cnt}}</div>
        <div v-if="washed_enabled" @click="filter_by_status('washed')" :style="selected_vehicle_status=='washed' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col washed">Washed-{{washed_cnt}}</div>
        <div @click="filter_by_status('dirty')" :style="selected_vehicle_status=='dirty' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col dirty">Dirty-{{dirty_cnt}}</div>
        <div @click="filter_by_status('out')" :style="selected_vehicle_status=='out' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col out">Out-{{out_cnt}}</div>
        <div @click="filter_by_status('oos')" :style="selected_vehicle_status=='oos' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col oos">OOS-{{oos_cnt}}</div>
        <div v-if="!standalone && base_options && base_options.length > 2" class="col" style="border: none"><b-form-select v-model="selected_base" :options="base_options" style="font-size: 20px; font-weight: bold; width:180px"/></div>
        <div v-if="!standalone && vehicle_tag_options && vehicle_tag_options.length > 2" class="col" style="border: none"><b-form-select v-model="selected_vehicle_tag" :options="vehicle_tag_options" style="font-size: 20px; font-weight: bold; width:180px"/></div>
        <div class="col d-flex align-items-center justify-content-center" style="border: none"><b-form-input style="font-size: 20px; font-weight: bold; width: 185px" v-model="search_filter" placeholder="filter by keyword"/></div>
        <div style="margin-top: 6px"><b-btn size="sm" @click="load_data()"><span style="font-size: 20px; font-weight: bold;">Reload</span></b-btn>
          &nbsp;&nbsp;<b-btn size="sm" @click="download()"><span style="font-size: 20px; font-weight: bold;">Download</span></b-btn>
          <span v-if="!standalone && summary.include_vehicle_info_only_enabled">
            &nbsp;&nbsp;<b-btn size="sm" @click="show_add_vehicle_info_modal = !show_add_vehicle_info_modal"><span style="font-size: 20px; font-weight: bold;">Add</span></b-btn>
          </span>
        </div>
      </div>
    </div>
    <div v-if="!loading && mobile_view">
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 18px;">
        <div @click="filter_by_status(null)" :style="selected_vehicle_status==null ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col total" style="border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
        <div v-if="washed_enabled" @click="filter_by_status('ready')" :style="selected_vehicle_status=='ready' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col ready">Ready-{{ready_cnt}}</div>
      </div>
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 18px;">
        <div @click="filter_by_status('cleaned')" :style="selected_vehicle_status=='cleaned' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col cleaned">Clean-{{clean_cnt}}</div>
        <div v-if="washed_enabled" @click="filter_by_status('washed')" :style="selected_vehicle_status=='washed' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col washed">Washed-{{washed_cnt}}</div>
        <div @click="filter_by_status('dirty')" :style="selected_vehicle_status=='dirty' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col dirty">Dirty-{{dirty_cnt}}</div>
      </div>
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 18px;">
        <div @click="filter_by_status('out')" :style="selected_vehicle_status=='out' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col out">Out-{{out_cnt}}</div>
        <div @click="filter_by_status('oos')" :style="selected_vehicle_status=='oos' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col oos">OOS-{{oos_cnt}}</div>
      </div>
      <div class="col d-flex align-items-center justify-content-center" style="border: none; margin-bottom: 5px"><b-form-input style="font-size: 18px; font-weight: bold;" v-model="search_filter" placeholder="filter by keyword"/></div>
    </div>
    <div v-if="summary">
      <b-table :busy="loading" :sticky-header="windowHeight ? windowHeight*.90 + 'px':'80vh'" bordered :items="items" :fields="visibleFields" :tbody-tr-class="get_row_color"
               :current-page="currentPage" :sort-compare="tableSortCompare" :style="'font-size:' + summary.font_size + 'px'" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
          </div>
        </template>

        <template slot="notes" slot-scope="row">
          <span v-if="row.item.future_booking">&nbsp;</span>
          <span v-else>
            <div v-if="!standalone" class="d-flex align-items-center justify-content-center">
              <b-form-input :style="'font-size:' + summary.font_size + 'px; min-width:200px'" v-model="row.item.notes" :disabled="updating" v-on:blur="update_notes(row, row.item)"/>
            </div>
            <div style="text-align: left" v-else>{{row.item.notes}}</div>
          </span>
        </template>

        <template slot="name" slot-scope="row">
          <a style="font-size: 22px" target="_blank" :href="'/#/vehicle-track/' + tenant_id + '/' + row.item.name">{{row.item.name}}</a>
        </template>

        <template slot="vehicle_odo" slot-scope="row">
          <span v-if="row.item.vehicle_info.obdOdometer">
            {{Number(row.item.vehicle_info.obdOdometer) | numberWithCommas}}
          </span>
        </template>

        <template slot="vehicle_fuel" slot-scope="row">
          <span v-if="row.item.vehicle_info.fuel_percent">
            {{row.item.vehicle_info.fuel_percent}}%
          </span>
        </template>

        <template slot="vehicle_def" slot-scope="row">
          <span v-if="row.item.vehicle_info.def_percent">
            {{row.item.vehicle_info.def_percent}}%
          </span>
        </template>

        <template slot="vehicle_status" slot-scope="row">
          <span v-if="row.item.future_booking">
            FUTURE
          </span>
          <span v-else>
            <b-form-select v-if="standalone && (summary.visible_update_fields && summary.visible_update_fields.indexOf('username') == -1)" :style="'font-size:' + summary.font_size + 'px'" v-model="row.item.vehicle_status" :options="status_options" @change="add_new_status_record(row, row.item)"/>
            <b-form-select v-else-if="!standalone" :style="'font-size:' + summary.font_size + 'px'" v-model="row.item.vehicle_status" :options="status_options" @change="update_vehicle_status(row, row.item)"/>
            <span v-else>{{row.item.vehicle_status}}</span>
          </span>
        </template>

        <template slot="confirmed_status" slot-scope="row">
          <div v-if="row.item.confirmed_time" style="font-weight: bold; background-color: lightgreen">
            {{row.item.confirmed_time | formatDateTimeCustom(summary.datetime_format)}}
          </div>
          <div v-else-if="row.item.confirmed_status == 'sent'" style="font-weight: bold; background-color: lightsalmon">
            {{row.item.confirmed_sent_time | formatDateTimeCustom(summary.datetime_format)}}
          </div>
          <div v-else-if="row.item.confirmed_status == 'unconfirmed'" style="font-weight: bold; background-color: coral">
            {{row.item.confirmed_sent_time | formatDateTimeCustom(summary.datetime_format)}}
          </div>
          <div v-else-if="!standalone">
            <b-btn size="sm" @click="manually_confirm_driver(row.item)"><span style="font-size: 14px; font-weight: bold">confirm</span></b-btn>
          </div>
        </template>

        <template slot="washbay_assignment" slot-scope="row">
            <b-form-select v-if="!standalone" v-model="row.item.washbay_assignment" :options="washbay_assignment_options" @change="update_vehicle_status(row, row.item)"/>
            <span v-else>{{row.item.washbay_assignment}}</span>
        </template>

        <template slot="next_scheduled_config" slot-scope="row">
          <b-form-select v-if="!standalone" :style="'font-size:' + summary.font_size + 'px'" v-model="row.item.next_scheduled_config" :options="scheduled_options" @change="update_next_scheduled_config(row, row.item)"/>
          <span v-else>{{row.item.next_scheduled_config}}</span>
        </template>

        <template slot="last_gps_time" slot-scope="row">
          {{row.item.last_gps_time | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="processed_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.processed_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_dirty_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_dirty_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_oos_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_oos_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="dump_date" slot-scope="row">
            {{row.item.dump_date | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="detailed_date" slot-scope="row">
          {{row.item.detailed_date | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="wrapped_date" slot-scope="row">
          {{row.item.wrapped_date | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="last_returned_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_returned_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_cleaned_time" slot-scope="row">
          <span v-if="row.item.last_cleaned_time">
            {{row.item.last_cleaned_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_cleaned_number" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_cleaned_number}}
          </span>
        </template>

        <template slot="last_washed_time" slot-scope="row">
          <span v-if="row.item.vehicle_info" :style="row.item.last_washed_delta ? 'color:red' : ''">
              {{row.item.last_washed_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_bathroom_cleaned_time" slot-scope="row">
          <span v-if="row.item.last_bathroom_cleaned_time" :style="row.item.last_bathroom_cleaned_delta ? 'color:red' : ''">
              {{row.item.last_bathroom_cleaned_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_def_filled_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
              {{row.item.last_def_filled_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_diesel_filled_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
              {{row.item.last_diesel_filled_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_washed_number" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_washed_number}}
          </span>
        </template>

        <template slot="last_ready_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_ready_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="current_mvmt_return_delta" slot-scope="row">
          <span v-if="row.item.current_mvmt_return_delta" :style="row.item.current_mvmt_return_delta.indexOf('d') != -1 ? '' : 'color: green'">
            {{row.item.current_mvmt_return_delta}}
          </span>
        </template>

        <template slot="next_mvmt_start_base" slot-scope="row">
          {{row.item.next_mvmt_start_base}}&nbsp;
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_start_base}}&nbsp;
          </template>
        </template>

        <template slot="next_mvmt_start_finish_base" slot-scope="row">
          {{row.item.next_mvmt_start_base | trim(15)}} / {{row.item.next_mvmt_finish_base | trim(15)}}
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_start_base | trim(15)}} / {{next_mvmt.next_mvmt_finish_base | trim(15)}}
          </template>
        </template>

        <template slot="next_scheduled_time" slot-scope="row">
          <div v-if="!standalone">
            <datetime style="margin: 5px;border-radius: 5px;" format="MM/DD/YYYY H:i" :value="row.item.next_scheduled_time" @input="update_next_scheduled_time(row,row.item,$event)"/>
          </div>
          <div v-else>
            {{row.item.next_scheduled_time | formatDateTimeCustom(summary.datetime_format)}}
          </div>
        </template>

        <template slot="wrap_scheduled_time" slot-scope="row">
          <div v-if="!standalone">
            <datetime style="margin: 5px;border-radius: 5px;" format="MM/DD/YYYY H:i" :value="row.item.wrap_scheduled_time" @input="update_wrap_scheduled_time(row,row.item,$event)"/>
          </div>
          <div v-else>
            {{row.item.wrap_scheduled_time | formatDateTimeCustom(summary.datetime_format)}}
          </div>
        </template>

        <template slot="next_daily_scheduled_time" slot-scope="row">
          {{row.item.next_daily_scheduled_time | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="next_mvmt_return_time" slot-scope="row">
          {{row.item.next_mvmt_return_time | formatDateTimeCustom(summary.datetime_format)}}
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_return_time | formatDateTimeCustom(summary.datetime_format)}}
          </template>
        </template>
        
        <template slot="current_mvmt_driver" slot-scope="row">
          <template v-if="row.item.current_mvmt_driver" v-for="driver,idx in row.item.current_mvmt_driver">
            <span v-if="idx>0"><br/></span>
            {{driver | trim(20)}}
          </template>
        </template>

        <template slot="next_mvmt_driver" slot-scope="row">
          <span v-if="row.item.next_mvmt_driver">
            <span v-for="driver,idx in row.item.next_mvmt_driver">
              <span v-if="idx>0"><br/></span>
              <span v-if="driver">
                {{driver.replace(/[^a-zA-Z ]/g, '') | trim(25)}}
              </span>
            </span>
          </span>
          <span v-if="!driver_mode && row.item.next_mvmt_list.length > 0" v-for="next_mvmt in row.item.next_mvmt_list">
            <span v-if="next_mvmt.next_mvmt_driver">
              <br/>{{next_mvmt.next_mvmt_driver.replace(/[^a-zA-Z ]/g, '') | trim(25)}}
            </span>
            <span v-else>
              <br/>&nbsp;
            </span>
          </span>
        </template>

        <template slot="next_mvmt_driver_phone" slot-scope="row">
          <template v-for="driver,idx in row.item.next_mvmt_driver_phone">
            <span v-if="idx>0"><br/></span>
            {{driver | prettyPhoneNumber}}
          </template>
          <template v-if="!driver_mode && row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <span v-if="next_mvmt.next_mvmt_driver_phone">
              <br/>{{next_mvmt.next_mvmt_driver_phone | prettyPhoneNumber}}
            </span>
            <span v-else>
              <br/>&nbsp;
            </span>
          </template>
        </template>

        <template slot="current_mvmt_return_time" slot-scope="row">
          {{row.item.current_mvmt_return_time | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="unifi_status" slot-scope="row">
          <span v-if="row.item.unifi_status == 'online'">
            {{row.item.unifi_status}}
          </span>
          <span v-else>
            {{row.item.unifi_status | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="next_mvmt_days" slot-scope="row">
          {{row.item.next_mvmt_days}}
          <template v-if="!driver_mode && row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_days}}
          </template>
        </template>

        <template slot="next_mvmt_time" slot-scope="row">
          {{row.item.next_mvmt_time | formatDateTimeCustom(summary.datetime_format)}}
          <template v-if="!driver_mode && row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_time | formatDateTimeCustom(summary.datetime_format)}}
          </template>
        </template>

        <template slot="next_mvmt_driver_time" slot-scope="row">
          {{row.item.next_mvmt_driver_time | formatDateTimeCustom(summary.datetime_format)}}
          <template v-if="!driver_mode && row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_driver_time | formatDateTimeCustom(summary.datetime_format)}}
          </template>
        </template>

        <template slot="next_mvmt_id" slot-scope="row">
          <router-link style="font-weight: bold;" :to="{ path: '/actuals?booking_id=' + row.item.next_mvmt_booking_hash }">{{ row.item.next_mvmt_id }}</router-link>
          <template v-if="!driver_mode && row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_id}}
          </template>
        </template>

        <template slot="next_mvmt_delta" slot-scope="row">
          <span v-if="row.item.next_mvmt_delta" :style="row.item.next_mvmt_delta.indexOf('d') != -1 ? '' : 'color: red'">
            {{row.item.next_mvmt_delta}}
          </span>
          <template v-if="!driver_mode && row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_delta}}
          </template>
        </template>

        <template slot="delete" slot-scope="row">
          <div style="font-weight: bold; color: darkred; padding:3px" @click="delete_status_record(row, row.item)">X</div>
        </template>

        <template slot="details" slot-scope="row">
          <span v-if="row.item.future_booking">&nbsp;</span>
          <b-button v-else-if="standalone && summary.visible_update_fields && summary.visible_update_fields.indexOf('username') != -1" size="lg" style="margin: 10px" @click="row.toggleDetails(); updating = !updating">
            Update
          </b-button>
          <b-button v-else-if="!standalone || summary.visible_update_fields" size="sm" @click="get_vehicle_info_history(row.item); row.toggleDetails();">
              {{ row.detailsShowing ? '-' : '+' }}
          </b-button>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card style="background-color: white; text-align: left;">

            <div v-if="summary.visible_update_fields">
              <b>Add New Status Record</b>
              <div class="row" style="font-weight: bold; margin: 5px">
                <div v-if="standalone && summary.visible_update_fields.indexOf('username') != -1" style="padding: 5px; margin: 5px" class="d-flex align-items-center justify-content-center">Username:&nbsp;&nbsp;<b-form-input style="width: 150px" v-model="row.item.username"/></div>
                <div style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Status:&nbsp;&nbsp;<b-form-select style="width: 200px" v-model="row.item.vehicle_status" :options="status_options"/></div>
                <div v-if="summary.visible_update_fields.indexOf('odometer') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Odometer:&nbsp;&nbsp;<b-form-input style="width: 150px" v-model="row.item.odometer"/></div>
                <div v-if="summary.visible_update_fields.indexOf('fuel_level') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Fuel:&nbsp;&nbsp;<b-form-input style="width: 150px" v-model="row.item.fuel_level"/></div>
                <div v-if="summary.visible_update_fields.indexOf('def_level') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">DEF:&nbsp;&nbsp;<b-form-input style="width: 150px" v-model="row.item.def_level"/></div>
                <div v-if="summary.visible_update_fields.indexOf('dump_date') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Dump:&nbsp;&nbsp;<b-form-checkbox size="lg" v-model="row.item.dump_date"/></div>
                <div v-if="summary.visible_update_fields.indexOf('detailed_date') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Detailed:&nbsp;&nbsp;<b-form-checkbox size="lg" v-model="row.item.detailed_date"/></div>
                <div v-if="summary.visible_update_fields.indexOf('wrapped_date') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Wrapped:&nbsp;&nbsp;<b-form-checkbox size="lg" v-model="row.item.wrapped_date"/></div>

                <div v-if="summary.visible_update_fields.indexOf('last_cleaned_time') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Interior Cleaned:&nbsp;&nbsp;<b-form-checkbox size="lg" v-model="row.item.update_cleaned_time"/></div>
                <div v-if="summary.visible_update_fields.indexOf('last_washed_time') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Exterior Washed:&nbsp;&nbsp;<b-form-checkbox size="lg" v-model="row.item.update_washed_time"/></div>
                <div v-if="summary.visible_update_fields.indexOf('last_bathroom_cleaned_time') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Bathroom Cleaned:&nbsp;&nbsp;<b-form-checkbox size="lg" v-model="row.item.update_bathroom_cleaned_time"/></div>
                <div v-if="summary.visible_update_fields.indexOf('last_def_filled_time') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">DEF Filled:&nbsp;&nbsp;<b-form-checkbox size="lg" v-model="row.item.update_def_filled_time"/></div>
                <div v-if="summary.visible_update_fields.indexOf('last_diesel_filled_time') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Diesel Filled:&nbsp;&nbsp;<b-form-checkbox size="lg" v-model="row.item.update_diesel_filled_time"/></div>

                <div style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Notes:&nbsp;&nbsp;<b-form-input style="width: 150px" v-model="row.item.notes"/></div>
                <div style="padding: 15px; margin: 5px"><b-button variant="success" size="md" @click="add_new_status_record(row, row.item)">Save Record</b-button></div><br/>
                <div style="padding: 15px; margin: 5px"><b-button variant="success" size="md" @click="delete_status_record(row, row.item)">Delete Record</b-button></div><br/>
                <b-alert v-model="alert.show" :variant="alert.variant" dismissible fade>
                  {{alert.message}}
                </b-alert>
              </div>
              <hr/>
            </div>
            <span v-if="!standalone && row.item.history && row.item.history.length > 0">
            <b>Status Change History</b>
              <b-table bordered :items="row.item.history" :fields="visibleHistoryFields" :tbody-tr-class="get_history_row_color">
              <template slot="processed_time" slot-scope="row">
                {{row.item.processed_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_dirty_time" slot-scope="row">
                {{row.item.last_dirty_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_cleaned_time" slot-scope="row">
                {{row.item.last_cleaned_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_washed_time" slot-scope="row">
                {{row.item.last_washed_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_bathroom_cleaned_time" slot-scope="row">
                {{row.item.last_bathroom_cleaned_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_def_filled_time" slot-scope="row">
                {{row.item.last_def_filled_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_diesel_filled_time" slot-scope="row">
                {{row.item.last_diesel_filled_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_ready_time" slot-scope="row">
                {{row.item.last_ready_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="detailed_date" slot-scope="row">
                {{row.item.detailed_date | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="wrapped_date" slot-scope="row">
                {{row.item.wrapped_date | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="dumped_date" slot-scope="row">
                {{row.item.dumped_date | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_out_time" slot-scope="row">
                {{row.item.last_out_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_returned_time" slot-scope="row">
                {{row.item.last_returned_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="notes" slot-scope="row">
                <div style="margin:3px; text-align: left">{{row.item.notes}}</div>
              </template>
              <template slot="dump_date" slot-scope="row">
                  {{row.item.dump_date | formatDateTimeCustom(summary.datetime_format)}}
              </template>

              <template slot="detailed_date" slot-scope="row">
                {{row.item.detailed_date | formatDateTimeCustom(summary.datetime_format)}}
              </template>

              <template slot="wrapped_date" slot-scope="row">
                {{row.item.wrapped_date | formatDateTimeCustom(summary.datetime_format)}}
              </template>

              <template slot="confirmed_status" slot-scope="row">
                <div v-if="row.item.confirmed_time">
                  {{row.item.confirmed_time | formatDateTimeCustom(summary.datetime_format)}}
                </div>
                <div v-else-if="row.item.confirmed_sent_time">
                  {{row.item.confirmed_sent_time | formatDateTimeCustom(summary.datetime_format)}}
                </div>
              </template>

            </b-table>
            </span>
          </b-card>
        </template>
      </b-table>
      <b-row v-if="!standalone && items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else-if="loading">
      <div class="text-center text-danger my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>

import {api_url, delete_vehicle_status, get_vehicle_info, get_vehicle_info_history, update_vehicle_status, update_vehicle_status_anonymous} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';
import {justDate} from "../helpers/dates";
import axios from "axios";

export default {
  name: 'vehicle_status',
  components: {
     datetime
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      windowHeight: window.innerHeight,
      search_filter: '',
      tenant_id: null,
      show_add_vehicle_info_modal: false,
      add_vehicle_info_model: {'manual_record': true},
      updating: false,
      washed_enabled: false,
      standalone: false,
      mobile_view: false,
      driver_mode: false,
      cleaning_mode: false,
      maintenance_mode: false,
      view_more_info: false,
      update_status_modal: false,
      columnSelection: false,
      reloading: false,
      reload_mode: 0,
      return_mode: false,
      timer: null,
      items: [],
      items_full: [],
      summary: null,
      loading: true,
      selected_vehicle_status: '',
      selected_base: '',
      selected_vehicle_tag: '',
      base_options: [],
      vehicle_tag_options: [],
      scheduled_options: [],
      washbay_assignment_options: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      status_options: [
        { value: '', text: 'ALL' },
        { value: 'READY', text: 'READY' },
        { value: 'CLEANED', text: 'CLEANED' },
        { value: 'WASHED', text: 'WASHED' },
        { value: 'DIRTY', text: 'DIRTY' },
        { value: 'OUT', text: 'OUT' },
        { value: 'OOS', text: 'OOS' },
      ],
      reload_options: [
        { value: 0, text: 'OFF' },
        { value: 30000, text: '30s' },
        { value: 60000, text: '1m' },
        { value: 300000, text: '5m' },
      ],
      fields: [
        { key: 'delete', label: '', sortable: false, visible: true, thStyle: { width: "30px" }},
        { key: 'details', label: '', sortable: false, visible: true, thStyle: { width: "30px" }},
        { key: 'name', label: 'Vehicle', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'vehicle_odo', label:'Odo', sortable: false, visible: true, thStyle: { width: "50px" }},
        { key: 'vehicle_fuel', label:'Fuel', sortable: false, visible: true, thStyle: { width: "40px" }},
        { key: 'vehicle_def', label:'DEF', sortable: false, visible: true, thStyle: { width: "40px" }},
        { key: 'vehicle_status', label:'Status', sortable: true, visible: true, thStyle: { width: "130px" }},
        { key: 'unifi_status', label:'Unifi', sortable: true, visible: true, thStyle: { width: "130px" }},
        { key: 'vehicle_tags', label:'Tags', sortable: true, visible: true},
        { key: 'current_mvmt_id', label: 'Current ID', sortable: true, visible: true, thStyle: { width: "120px" }},
        { key: 'current_mvmt_driver', label: 'Current Driver', sortable: true, visible: true, thStyle: { width: "175px" }},
        { key: 'confirmed_status', label: 'Driver Confirm', sortable: true, visible: true, thStyle: { width: "120px" }},
        { key: 'washbay_assignment', label: 'Washbay Assignment', sortable: true, visible: true, thStyle: { width: "175px" }},
        { key: 'current_start_base', label: 'Current Start', sortable: true, visible: true},
        { key: 'current_finish_base', label: 'Current Finish', sortable: true, visible: true},
        { key: 'current_mvmt_return_time', label: 'Returning', sortable: true, visible: true, thStyle: { width: "160px" }},
        { key: 'current_mvmt_return_delta', label: 'Returns In', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_dirty_time', label:'Last Dirty', sortable: true, visible: true},
        { key: 'last_cleaned_time', label:'Cleaned Time', sortable: true, visible: true, thStyle: { width: "160px" }},
        { key: 'last_cleaned_number', label:'Cleaned #', sortable: true, visible: true},
        { key: 'last_washed_time', label:'Washed Time', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_bathroom_cleaned_time', label:'Bathroom Cleaned', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_def_filled_time', label:'DEF Filled', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_diesel_filled_time', label:'Diesel Filled', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_washed_number', label:'Washed #', sortable: true, visible: true},
        { key: 'last_ready_time', label:'Last Ready', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_returned_time', label: 'Last Return', sortable: true, visible: true, thStyle: { width: "160px" }},
        { key: 'dump_date', label:'Dump Date', visible: false, sortable: true, thStyle: { width: "140px" }},
        { key: 'detailed_date', label:'Detailed Date', visible: false, sortable: true, thStyle: { width: "160px" }},
        { key: 'wrapped_date', label:'Wrapped Date', visible: false, sortable: true, thStyle: { width: "160px" }},
        { key: 'wrap_scheduled_time', label:'Wrap Scheduled', visible: false, sortable: true, thStyle: { width: "160px" }},
        { key: 'next_mvmt_start_base', label: 'Next Start', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'next_mvmt_start_finish_base', label: 'Next Start / Finish', sortable: true, visible: true, thStyle: { width: "230px" }},
        { key: 'next_mvmt_driver', label: 'Next Driver', sortable: true, visible: true, thStyle: { width: "175px" }},
        { key: 'next_mvmt_client_ref1_route', label: 'Reference', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'next_mvmt_driver_phone', label: 'Driver #', sortable: true, visible: true, thStyle: { width: "130px" }},
        { key: 'next_mvmt_id', label: 'Next ID', sortable: true, visible: true, thStyle: { width: "120px" }},
        { key: 'next_mvmt_booking_type', label:'Booking Type', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'next_mvmt_return_time', label:'Next Return', sortable: true, thStyle: { width: "160px" }},
        { key: 'next_scheduled_time', label:'Scheduled Time', sortable: true, visible: true, thStyle: { width: "180px" }},
        { key: 'next_daily_scheduled_time', label:'Next Daily', sortable: true, visible: true, thStyle: { width: "180px" }},
        { key: 'next_scheduled_config', label:'Daily Schedule', sortable: true, visible: true, thStyle: { width: "220px" }},
        { key: 'next_mvmt_driver_time', label:'Next Driver Start', sortable: true, visible: true, thStyle: { width: "160px" }},
        { key: 'next_mvmt_time', label:'Next Depart', sortable: true, visible: true, thStyle: { width: "160px" }},
        { key: 'next_mvmt_delta', label:'Departs In', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'next_mvmt_days', label:'#', sortable: true, visible: true, thStyle: { width: "50px" }},
        { key: 'next_mvmt_distance', label:'Miles', sortable: true, visible: true, thStyle: { width: "80px" }},

        { key: 'next_mvmt_client_ref1', label:'Customer', sortable: true, visible: true, thStyle: { width: "20px" }},
        { key: 'next_mvmt_pickup', label:'Pickup', sortable: true, visible: true, thStyle: { width: "300px" }},
        { key: 'next_mvmt_destination', label:'Destination', sortable: true, visible: true, thStyle: { width: "300px" }},

        { key: 'odometer', label:'Odometer', visible: false, sortable: true},
        { key: 'fuel_level', label:'Fuel', visible: false, sortable: true},
        { key: 'def_level', label:'DEF', visible: false, sortable: true},
        { key: 'notes', label: 'Notes', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'update_status', label: '', sortable: false, visible: true, thStyle: { width: "200px" }},
      ],
      history_fields: [
        { key: 'processed_time', label:'Last Updated', visible: true, sortable: true},
        { key: 'updated_by', label:'Updated By', visible: true, sortable: true},
        { key: 'vehicle_status', label:'Status', visible: true, sortable: true},
        { key: 'confirmed_status', label: 'Driver Confirm', sortable: true},
        { key: 'booking_hash', label:'Booking', sortable: true, visible: true},
        { key: 'last_cleaned_time', label:'Cleaned', visible: true, sortable: true},
        { key: 'last_cleaned_number', label:'Cleaned #', visible: true, sortable: true},
        { key: 'last_washed_time', label:'Washed', visible: true, sortable: true},
        { key: 'last_washed_number', label:'Washed #', visible: true, sortable: true},
        { key: 'last_bathroom_cleaned_time', label:'Bathroom Cleaned', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_def_filled_time', label:'DEF Filled', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_diesel_filled_time', label:'Diesel Filled', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_ready_time', label:'Ready', visible: true, sortable: true},
        { key: 'last_returned_time', label: 'Returned Time', sortable: true, visible: true},
        { key: 'detailed_date', label:'Detailed Date', visible: false, sortable: true},
        { key: 'wrapped_date', label:'Wrapped Date', visible: false, sortable: true},
        { key: 'dump_date', label:'Dump Date', visible: false, sortable: true, thStyle: { width: "140px" }},
        { key: 'next_scheduled_time', label:'Scheduled Time', sortable: true, visible: true},
        { key: 'odometer', label:'Odometer', visible: false, sortable: true},
        { key: 'fuel_level', label:'Fuel', visible: false, sortable: true},
        { key: 'def_level', label:'DEF', visible: false, sortable: true},
        { key: 'notes', label: 'Notes', visible: true, sortable: true},
      ]
    }
  },
  async created() {
    this.fields_all = this.fields
    await this.check_features()
  },
  mounted() {
    this.stopTimer()
  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    startTimer() {
      this.stopTimer()
      if (this.reload_mode > 0) {
        this.timer = setInterval(() => this.reload_data(), this.reload_mode)
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async resetTimerAndReload() {
      this.stopTimer()
      await this.reload_data()
      this.startTimer()
    },

    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.mobile_view = true;
        return true
      } else {
        return false
      }
    },
    isTablet() {
      if(/iPad/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    tableSortCompare(aRow, bRow, key) {
      if (key == 'next_mvmt_delta') {
        return aRow['next_mvmt_ms'] - bRow['next_mvmt_ms']
      }
      if (key == 'current_mvmt_return_delta') {
        return aRow['current_mvmt_return_ms'] - bRow['current_mvmt_return_ms']
      }
      return false;
    },
    async check_features() {

      if (this.$route.path.indexOf('/vsm-v1/') == -1) {
        this.standalone = false
        this.tenant_id = this.user.tenant
      }
      else if (this.$route.path.indexOf('/vsm-v1/reload/') != -1) {
        this.standalone = true
        let filter = this.$route.path.split('/vsm-v1/reload/')[1]

        if (filter.indexOf('/tag') != -1) {
          this.tenant_id = filter.split("/tag/")[0];
          this.selected_vehicle_tag = filter.split("/tag/")[1];
        } else if (filter.indexOf('/') != -1) {
          this.tenant_id = filter.split("/")[0];
          this.selected_base = filter.split("/")[1];
        } else {
          this.tenant_id = filter;
        }

        this.reload_mode = 60000
      }
      else if (this.$route.path.indexOf('/vsm-v1/reloadreturn/') != -1) {
        this.standalone = true
        this.return_mode = true
        let filter = this.$route.path.split('/vsm-v1/reloadreturn/')[1]

        if (filter.indexOf('/tag') != -1) {
          this.tenant_id = filter.split("/tag/")[0];
          this.selected_vehicle_tag = filter.split("/tag/")[1];
        } else if (filter.indexOf('/') != -1) {
          this.tenant_id = filter.split("/")[0];
          this.selected_base = filter.split("/")[1];
        } else {
          this.tenant_id = filter;
        }

        this.reload_mode = 60000
      }
      else if (this.$route.path.indexOf('/vsm-v1/driver/') != -1) {
        this.standalone = true
        this.driver_mode = true
        let filter = this.$route.path.split('/vsm-v1/driver/')[1]
        this.tenant_id = filter.split("/")[0];
        this.selected_base = filter.split("/")[1];
        this.reload_mode = 60000
      }
      else if (this.$route.path.indexOf('/vsm-v1/cleaning/') != -1) {
        this.standalone = true
        this.cleaning_mode = true
        let filter = this.$route.path.split('/vsm-v1/cleaning/')[1]
        this.tenant_id = filter.split("/")[0];
        this.selected_base = filter.split("/")[1];
        this.reload_mode = 60000
      }
      else if (this.$route.path.indexOf('/vsm-v1/maintenance/') != -1) {
        this.standalone = true
        this.maintenance_mode = true
        let filter = this.$route.path.split('/vsm-v1/maintenance/')[1]
        this.tenant_id = filter.split("/")[0];
        this.selected_base = filter.split("/")[1];
        this.reload_mode = 60000
      }

      this.fields = this.fields_all

      if (this.isMobile())
        this.fields = this.fields.filter(item => (item.key == 'name' || item.key == 'vehicle_status' || item.key == 'next_mvmt_delta'))

      if (this.isTablet())
        this.fields = this.fields.filter(item => (item.key != 'current_mvmt_return_time' && item.key != 'last_ready_time' && item.key != 'next_mvmt_start_base' && item.key != 'next_mvmt_id'))

      // if (this.return_mode)
      //   this.fields = this.fields.filter(item => (item.key != 'next_mvmt_delta'))

      this.load_data()
    },
    async update_next_scheduled_config(row, item) {
      if (this.reloading)
        return;

      this.updating = true
      try {

        let json = {
          'name': item.name,
          'next_scheduled_config':  item.next_scheduled_config,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)

        if (data.next_mvmt_ms && (!item.next_mvmt_ms || data.next_mvmt_ms < item.next_mvmt_ms)) {
          item.next_mvmt_delta = data.next_mvmt_delta
          item.next_mvmt_ms = data.next_mvmt_ms
        }
        item.next_daily_scheduled_time = data.next_daily_scheduled_time

        if (row.detailsShowing)
          row.toggleDetails();

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },
    async update_next_scheduled_time(row, item, next_scheduled_time) {
      if (this.reloading)
        return;

      this.updating = true
      try {

        let json = {
          'name': item.name,
          'next_scheduled_time':  next_scheduled_time,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)

        if (data.next_mvmt_ms && (!item.next_mvmt_ms || data.next_mvmt_ms < item.next_mvmt_ms)) {
          item.next_mvmt_delta = data.next_mvmt_delta
          item.next_mvmt_ms = data.next_mvmt_ms
        }

        if (row.detailsShowing)
          row.toggleDetails();

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },
    async update_wrap_scheduled_time(row, item, wrap_scheduled_time) {
      if (this.reloading)
        return;

      this.updating = true
      try {

        let json = {
          'name': item.name,
          'wrap_scheduled_time':  wrap_scheduled_time,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)

        if (row.detailsShowing)
          row.toggleDetails();

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },
    async update_vehicle_status(row, item) {
      console.log("updating vehicle status: " + item.name)

      this.updating = true
      try {

        let json = {
          'name': item.name,
          'vehicle_status':  item.vehicle_status,
          'washbay_assignment':  item.washbay_assignment,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)

        //update any caclulated fields that might have changed during the save
        if (data.vehicle_status)
          item.vehicle_status = data.vehicle_status
        if (data.dump_date)
          item.dump_date = data.dump_date
        if (data.detailed_date)
          item.detailed_date = data.detailed_date
        if (data.wrapped_date)
          item.wrapped_date = data.wrapped_date

        if (data.next_mvmt_delta) {
          item.next_mvmt_delta = data.next_mvmt_delta
          item.next_mvmt_ms = data.next_mvmt_ms
        }

        if (row.detailsShowing)
          row.toggleDetails();


      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },
    async add_new_status_record(row, item) {
      this.updating = true
      try {
        if (this.standalone) {
          try {
            if (this.summary.visible_update_fields.indexOf('username') == -1)
              item.username = 'anonymous'

            const {value: {data = []}} = await update_vehicle_status_anonymous(this.tenant_id, item)
            if (data.vehicle_status)
              item.vehicle_status = data.vehicle_status
            if (data.dump_date)
              item.dump_date = data.dump_date
            if (data.detailed_date)
              item.detailed_date = data.detailed_date
            if (data.wrapped_date)
              item.wrapped_date = data.wrapped_date

          } catch(e){
            this.showAlert("unable to save new status record, invalid username", 'danger', 5000)
            return;
          }
        } else {
          const {value: {data = []}} = await update_vehicle_status(this.tenant_id, item)
          if (data.vehicle_status)
            item.vehicle_status = data.vehicle_status
          if (data.dump_date)
            item.dump_date = data.dump_date
          if (data.detailed_date)
            item.detailed_date = data.detailed_date
          if (data.wrapped_date)
            item.wrapped_date = data.wrapped_date
          if (data.last_cleaned_time)
            item.last_cleaned_time = data.last_cleaned_time
          if (data.last_washed_time)
            item.last_washed_time = data.last_washed_time
          if (data.last_bathroom_cleaned_time)
            item.last_bathroom_cleaned_time = data.last_bathroom_cleaned_time
          if (data.last_def_filled_time)
            item.last_def_filled_time = data.last_def_filled_time
          if (data.last_diesel_filled_time)
            item.last_diesel_filled_time = data.last_diesel_filled_time
        }

        if (this.summary.visible_update_fields.indexOf('username') != -1)
          row.toggleDetails();

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.updating = false
    },
    async load_data() {
      this.loading = true
      try {
        var results = await get_vehicle_info(this.tenant_id, this.selected_base, this.selected_vehicle_tag, this.return_mode)
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.washed_enabled = this.summary.washed_enabled

        if (!this.washed_enabled)
          this.status_options = this.status_options.filter(item => (item.value != 'READY' && item.value != 'WASHED'))

        if (this.driver_mode)
          this.summary.font_size = 24

        this.base_options = data.summary.bases
        this.scheduled_options = data.summary.scheduled_options
        this.vehicle_tag_options = data.summary.vehicle_tags
        this.washbay_assignment_options = data.summary.washbay_assignment_options
        if (this.standalone && data.summary.window_height)
          this.windowHeight = data.summary.window_height

        this.filter_items()

        this.stopTimer()
        if (this.reload_mode > 0) {
          this.startTimer()
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, check your URL or contact support if needed', 'danger', 5000)
        this.stopTimer()
        this.loading = false
      }

      this.loading = false
    },
    async reload_data() {
      try {
        if (this.updating)
          return;

        if (this.$pageVisibility && this.$pageVisibility.hidden)
          return;

        if (this.reloading)
          return;

        this.reloading = true

        var results = await get_vehicle_info(this.tenant_id, this.selected_base, this.selected_vehicle_tag, this.return_mode)
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.base_options = data.summary.bases
        this.filter_items()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.reloading = false
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      const now = justDate(moment());
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/vehicles/download`,
          {
            tenant: this.user.tenant,
            base: this.selected_base,
            tag: this.selected_vehicle_tag,
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `vsm-${now}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
    async update_notes(row, item) {
      this.updating = true
      try {
        let json = {
          'name': item.name,
          'notes': item.notes,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)
        if (row.detailsShowing)
          row.toggleDetails();
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.updating = false
    },
    async add_vehicle_info_record() {
      this.updating = true
      try {
        await update_vehicle_status(this.tenant_id, this.add_vehicle_info_model)
        this.add_vehicle_info_model = {'manual_record': true}
        this.show_add_vehicle_info_modal = false
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.updating = false
      //this.reload_data()
    },
    async manually_confirm_driver(item) {
      this.updating = true
      item.confirmed_time = String(moment())

      try {
        let json = {
          'name': item.name,
          'confirmed_by': this.user.username,
          'confirmed_time': moment(),
          'confirmed_booking_hash': item.next_mvmt_booking_hash,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.$forceUpdate()
      this.updating = false
    },
    async delete_status_record(row, selected_item) {
      this.updating = true
      try {
        if(confirm("Do you really want to delete status record for " + selected_item.name + "?")) {
          const {value: {data = []}} = await delete_vehicle_status(this.tenant_id, selected_item)
          this.items = this.items.filter(item => item.name != selected_item.name)
        }
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.updating = false
    },
    async get_vehicle_info_history(selected_item) {
      const {value: { data = [] } } = await get_vehicle_info_history(this.tenant_id, selected_item.name)
      var history_item = this.items_full.filter(item => item.name == selected_item.name)[0]
      history_item.history = data
      this.$forceUpdate()
    },
    filter_by_status(status) {
      if (status == null || this.selected_vehicle_status == status) {
        this.selected_vehicle_status = null
      } else {
        this.selected_vehicle_status = status
      }
      this.filter_items()
    },
    filter_items(status) {
      this.items = this.items_full
      if (this.selected_vehicle_status) {
        this.items = this.items.filter(item => item.vehicle_status == this.selected_vehicle_status.toUpperCase())
      }
      if (this.selected_vehicle_tag) {
        this.items = this.items.filter(item => this.contains(item.vehicle_tags,this.selected_vehicle_tag))
      }
      if (status) {
        this.items = this.items.filter(item => item.vehicle_status == status)
      }
      if (this.search_filter != '') {
        this.items = this.items.filter(item => (this.contains(item.start_bases, this.search_filter) || this.contains(item.next_mvmt_driver, this.search_filter) || this.contains(item.name, this.search_filter) || this.contains(item.notes, this.search_filter)))
      }
    },
    get_filter_counts(status) {
      let items_tmp = this.items_full
      if (status) {
        items_tmp = items_tmp.filter(item => item.vehicle_status == status && !item.future_booking)
      }
      if (this.search_filter != '') {
        items_tmp = items_tmp.filter(item => (this.contains(item.start_bases, this.search_filter) || this.contains(item.name, this.search_filter)))
      }
      return items_tmp.length
    },

    contains(val1, val2) {
      if (val1 != null && val2 != null) {
        return String(val1).toLowerCase().indexOf(String(val2).toLowerCase()) != -1;
      }
      return false;
    },
    get_row_color(item) {
      if (item && !this.driver_mode) {
        if (item.vehicle_status)
          return item.vehicle_status.toLowerCase()
        else
          return "unknown";
      }
    },
    get_history_row_color(item) {
      return "unknown";
    },
},
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.isMobile() && this.summary.visible_mobile_fields)
        custom_fields = this.summary.visible_mobile_fields;
      else if (this.summary && this.driver_mode && this.summary.visible_driver_fields)
        custom_fields = this.summary.visible_driver_fields;
      else if (this.summary && this.cleaning_mode && this.summary.visible_cleaning_fields)
        custom_fields = this.summary.visible_cleaning_fields;
      else if (this.summary && this.maintenance_mode && this.summary.visible_maintenance_fields)
        custom_fields = this.summary.visible_maintenance_fields;
      else if (this.summary && this.standalone && this.summary.visible_standalone_fields)
        custom_fields = this.summary.visible_standalone_fields;
      else if (this.summary && this.summary.visible_fields)
        custom_fields = this.summary.visible_fields;

      if (this.standalone && !this.summary.visible_update_fields) {
        // this.fields_all = this.fields_all.filter(item => !(item.key == 'details' || item.key == 'delete'))
        // this.fields = this.fields.filter(item => !(item.key == 'details' || item.key == 'delete'))
      }

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.fields_all.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields.filter(field => field.visible)
    },
    visibleHistoryFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_history_fields)
        custom_fields = this.summary.visible_history_fields;

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.history_fields.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.history_fields
    },
    ready_cnt() {
      return this.get_filter_counts('READY')
    },
    clean_cnt() {
      return this.get_filter_counts('CLEANED')
    },
    washed_cnt() {
      return this.get_filter_counts('WASHED')
    },
    dirty_cnt() {
      return this.get_filter_counts('DIRTY')
    },
    out_cnt() {
      return this.get_filter_counts('OUT')
    },
    oos_cnt() {
      return this.get_filter_counts('OOS')
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_base(val) {
      this.load_data()
    },
    search_filter(val) {
      this.filter_items()
    },
    selected_vehicle_tag(val) {
      this.filter_items()
    },
    reload_mode(val) {
      this.stopTimer()
      if (val > 0) this.startTimer()
    },
    '$pageVisibility.hidden'(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.resetTimerAndReload()
      }
    }
  }
}
</script>

<style scoped>
.total { border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}

.cleaned { background-color: hsla(190,70%,50%,0.4); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}
.washed { background-color: hsla(160,30%,40%,0.4); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}
.ready { background-color: hsla(120,100%,75%,0.3); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}
.oos { background-color: hsla(357,78%,65%,0.4); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}
.dirty { background-color: hsla(25,28%,23%,0.4); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}
.out { background-color: hsla(290,60%,70%,0.3); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}

.unknown td { background-color: white !important;}
.cleaned td { background-color: hsla(190,70%,50%,0.4); border: 1px solid black !important;}
.washed td { background-color: hsla(160,30%,40%,0.4); border: 1px solid black !important; }
.ready td { background-color: hsla(120,100%,75%,0.3); border: 1px solid black !important; }
.oos td { background-color: hsla(357,78%,65%,0.4); border: 1px solid black !important; }
.dirty td { background-color: hsla(25,28%,23%,0.4); border: 1px solid black !important; }
.out td { background-color: hsla(290,60%,70%,0.3); border: 1px solid black !important; }

div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

.stats { border-radius: 5px; margin:2px}
</style>
